import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { APP_URL_ONELINK, NEVER_SHOW } from '../../../utils/constants';
import { injectIntoDataLayer } from '../../../utils/library';
import COLORS from '../../../common/styles/color-pallete';
import { CommonButton } from '@Components';
import { FONT_FAMILY } from '../../../common/styles/fontStyles';
import {
  APP_PROMOTION_ICON,
  APPLE_STORE_ICON,
  CLOSE_NEW_ICON,
  GOOGLE_PLAY_STORE_ICON
} from '@Images';

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  width: 335px;
  height: 418px;
  background: white;
  font-family: ${FONT_FAMILY.hellix.regular};
  border-radius: 5px;
  position: relative;
  padding: 22px;
`;
const StoreselectWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 16px;
  img {
    width: 118px;
    height: 39px;
  }
`;
const CloseButton = styled.div`
  position: absolute;
  top: 22px;
  right: 22px;
`;
const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;
const BoldHeader = styled.div`
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 28px;
  line-height: 38px;
`;
const NeverShowAgain = styled.div`
  color: ${COLORS.brandPrimary};
  font-size: 16px;
  font-family: ${FONT_FAMILY.hellix.bold};
`;
const NormalText = styled.div`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: ${(props) => props.size}px;
  line-height: ${(props) => props.height}px;
`;

const PromoteApp = (props) => {
  const { onClose, screen } = props;
  const neverShow = () => {
    window.localStorage.setItem(NEVER_SHOW, true);
    onClose();
  };
  return (
    <ModalContent>
      <CloseButton>
        <img onClick={onClose} className="app_promote_close" src={CLOSE_NEW_ICON} alt="close" />
      </CloseButton>
      <div>
        <img className="app_promote_like" src={APP_PROMOTION_ICON} alt="love" />
      </div>
      <HeaderSection>
        <BoldHeader>Take our app for a spin</BoldHeader>
        <NormalText size={20} height={24}>
          We&apos;re sure you&apos;ll love it
        </NormalText>
      </HeaderSection>
      <NormalText size={16} height={19}>
        Enjoy quick and easy money transfers at your fingertips
      </NormalText>
      <StoreselectWrapper>
        <div onClick={() => injectIntoDataLayer('appstore_' + screen)}>
          <a href={APP_URL_ONELINK}>
            <img src={APPLE_STORE_ICON} alt="apple-app-store" />
          </a>
        </div>
        <div onClick={() => injectIntoDataLayer('playstore_' + screen)}>
          <a href={APP_URL_ONELINK}>
            <img src={GOOGLE_PLAY_STORE_ICON} alt="google-play-store" />
          </a>
        </div>
      </StoreselectWrapper>
      <NeverShowAgain onClick={neverShow}>
        <CommonButton text="Dont show again" type="link" />
      </NeverShowAgain>
    </ModalContent>
  );
};

PromoteApp.propTypes = {
  onClose: PropTypes.func,
  screen: PropTypes.string
};

export default PromoteApp;
